import { cookieUtils } from './cookieUtils';

const TOKEN_KEY = 'token';
const USER_KEY = 'user';

export const tokenUtils = {
  // Métodos principales usando cookies
  get: () => cookieUtils.getToken(),
  set: (token) => cookieUtils.setToken(token),
  remove: () => cookieUtils.removeToken(),
  
  // Verificación de expiración
  isExpired: (token) => cookieUtils.isTokenExpired(token),
  
  // Manejo de usuario
  getUser: () => cookieUtils.getUser(),
  setUser: (user) => cookieUtils.setUser(user),
  removeUser: () => cookieUtils.removeUser(),
  
  // Método para limpiar toda la autenticación
  clearAuth: () => {
    cookieUtils.clearAuth();
    // También limpiar localStorage por compatibilidad
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem('usuarioConCedula');
    localStorage.removeItem('redirectAfterLogin');
  }
};
